import logo from '../assets/atad-logo-vertical.png';

export default function AuthLayout({ heading, children }) {
  return (
    <div className="h-screen w-screen flex overflow-auto">
      <div className="bg-background-dark flex flex-1">
        {heading && (
          <div className="p-10 w-full h-full text-white">{heading}</div>
        )}
      </div>
      <div className="flex flex-1 flex-col items-center justify-center px-5">
        <img className="sm-h:mb-6 mb-14 sm-h:h-28 h-40" src={logo} alt="logo" />
        {children}
      </div>
    </div>
  );
}
